import * as React from 'react';
import { Text, Button } from '@fluentui/react-components';
import StatusBox from '../../../components/statusBox';
import { IDashboardFilter } from '../../../common/models';
import { lightThemeColors } from '../../../common/themes';

interface DashboardFilterProps {
  total: number,
  statusFilter: IDashboardFilter;
  onToggleFilter: (filterKey: string) => void;
  onClearFilter: () => void;
}

const TankFilter: React.FC<DashboardFilterProps> = ({
  total,
  statusFilter,
  onToggleFilter,
  onClearFilter,
}) => (
  <div>
    <div style={{ padding: 10, textAlign: 'center' }}>
      <Text weight="bold" >
        Tank Status
      </Text>
    </div>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 10,
      paddingBottom: 20,
    }}>
      <StatusBox
        title={ statusFilter.normal.name }
        color={ statusFilter.normal.color }
        bgColor={ statusFilter.normal.color }
        count={ statusFilter.normal.count }
        isSelected={ statusFilter.normal.isSelected as boolean }
        onToggle={ () => onToggleFilter('normal') }
      />
      <StatusBox
        title={ statusFilter.alarm.name }
        color={ statusFilter.alarm.color }
        bgColor={ statusFilter.alarm.color }
        count={ statusFilter.alarm.count }
        isSelected={ statusFilter.alarm.isSelected as boolean }
        onToggle={ () => onToggleFilter('alarm') }
      />
      <StatusBox
        title={ statusFilter.snoozed.name }
        color={ lightThemeColors.alarm }
        bgColor={ lightThemeColors.silence }
        count={ statusFilter.snoozed.count }
        isOutlined={true}
        isSelected={ statusFilter.snoozed.isSelected as boolean }
        onToggle={ () => onToggleFilter('snoozed') }
      />
      <StatusBox
        title={ statusFilter.warning.name }
        color={ statusFilter.warning.color }
        bgColor={ statusFilter.warning.color }
        count={ statusFilter.warning.count }
        isSelected={ statusFilter.warning.isSelected as boolean }
        onToggle={ () => onToggleFilter('warning') }
      />
      <StatusBox
        title={ statusFilter.muted.name }
        color={ statusFilter.muted.color }
        bgColor={ statusFilter.muted.color }
        count={ statusFilter.muted.count }
        isSelected={ statusFilter.muted.isSelected as boolean }
        onToggle={ () => onToggleFilter('muted') }
      />
      <StatusBox
        title={ statusFilter.inactive.name }
        color={ statusFilter.inactive.color }
        bgColor={ statusFilter.inactive.color }
        count={ statusFilter.inactive.count }
        isSelected={ statusFilter.inactive.isSelected as boolean }
        onToggle={ () => onToggleFilter('inactive') }
      />
      <Button
        disabled={!Object.values(statusFilter).some((x) => x.isSelected)}
        onClick={onClearFilter}
      >
        Clear Filters
      </Button>
      <Text>Total: {total} Tanks</Text>
    </div>
  </div>
);

export default TankFilter;
